
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { LayoutItemProps } from ".";
import { loading, index, options } from "store/layout";

interface ApiLayoutInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiLayoutOutputProps = OutputBaseProps<{ list: LayoutItemProps[]; pagination?: PaginationProps; }>

export const apiLayoutIndex = async (data: ApiLayoutInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLayoutOutputProps>("/api/layouts", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiLayoutOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLayoutOutputProps>("/api/layouts", { params: { ...data } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};